import React, { useState } from 'react'
import { FormControl, FormLabel, Select, MenuItem } from '@material-ui/core'
import { useForm } from '../../providers/FormProvider'
import { months, days, years } from '../../data/date'

import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => {
    return {
        label: {
            marginBottom: '0.5rem',
        },
        numOfRequirementContainer: {
            display: 'flex',
            justifyContent: 'space-between',
            gap: theme.spacing(4),
        },
        btn: {
            width: 'max-content',
            textTransform: 'none',
            marginBottom: '2rem',
        },
        flex: {
            display: 'flex',
            gap: theme.spacing(4),
        },
        title: {
            marginBottom: '0px',
        },
        formLabel: {
            marginBottom: theme.spacing(2),
        },
    }
})

export default function DatePicker(props) {
    const [date, setDate] = useState({
        day: '',
        month: '',
        year: '',
    })

    console.log(date)

    const classes = useStyles()
    const { formState, error } = useForm()

    return (
        <FormControl>
            <FormLabel>Start Date</FormLabel>
            <div className={classes.flex}>
                <FormControl className={classes.formControl}>
                    <FormLabel className={classes.formLabel}>Month</FormLabel>
                    <Select
                        labelId="month"
                        variant="outlined"
                        id="month"
                        value={formState.state}
                        onChange={(e) =>
                            setDate((prevDate) => {
                                return { ...prevDate, month: e.target.value }
                            })
                        }
                        error={error?.state}
                        helperText={error?.state?.error || ''}
                    >
                        {months ? (
                            months().map((month) => (
                                <MenuItem key={month.id} value={months.name}>
                                    {month.name}
                                </MenuItem>
                            ))
                        ) : (
                            <MenuItem id={'None'} value={''}>
                                Select a month
                            </MenuItem>
                        )}
                    </Select>
                </FormControl>
                <FormControl className={classes.formControl} error={error?.city} helperText={error?.city?.error || ''}>
                    <FormLabel className={classes.formLabel}>Day</FormLabel>

                    <Select
                        labelId="day"
                        id="day"
                        variant="outlined"
                        value={formState.city}
                        onChange={(e) => setDate((prevDate) => ({ ...prevDate, day: e.target.value }))}
                    >
                        {days ? (
                            days().map((day) => {
                                return (
                                    <MenuItem key={day} id={day} value={day}>
                                        {day}
                                    </MenuItem>
                                )
                            })
                        ) : (
                            <MenuItem id={'None'} value={''}>
                                Select a day
                            </MenuItem>
                        )}
                    </Select>
                </FormControl>
                <FormControl className={classes.formControl} error={error?.city} helperText={error?.city?.error || ''}>
                    <FormLabel className={classes.formLabel}>Year</FormLabel>

                    <Select
                        labelId="year"
                        id="year"
                        variant="outlined"
                        value={formState.city}
                        onChange={(e) => setDate((prevDate) => ({ ...prevDate, year: e.target.value }))}
                    >
                        {years ? (
                            years().map((year) => {
                                return (
                                    <MenuItem key={year} id={year} value={year}>
                                        {year}
                                    </MenuItem>
                                )
                            })
                        ) : (
                            <MenuItem id={'None'} value={''}>
                                Select a year
                            </MenuItem>
                        )}
                    </Select>
                </FormControl>
            </div>
        </FormControl>
    )
}
